export default __webpack_public_path__ + "f635e37586001f17efa0be8f532b69b4.svg";